export const TOUCH_TYPE = 'click';
// export const TOUCH_TYPE = 'touchstart';

// Флаг для включения/отключения дебаг функций
export const isDebug = false;